import { useEffect, useState } from "react"

import { useItems, itemTypes, targetTypes } from "../../../api/useItems"

export function useDataTransitionMain() {

    const { list, filterOperatorTypes } = useItems({ itemType: itemTypes.item, targetType: targetTypes.item })

    const init = ({ data = [] }) => {

        let nextRouteUrl = 'documents/purchaseOrder/new'
        let nextRoutePayload = {
            locationId: data?.locationId,
            locationDisplay: data?.locationDisplay,
            items: data?.items
        }

        return {
            nextRouteUrl,
            nextRoutePayload
        }

    }

    const catchTransition = async ({ formik, data }) => {

        const { locationId, locationDisplay, items } = data

        const { handleSubmit, handleChange, values, errors, touched, setFieldValue } = formik;

        const itemIds = items.map(i => i.itemId)

        // console.log('aaa', data, itemIds, items)
        // console.log('values', values)

        const props = {
            limit: -1,
            skip: 0,
            filterValue: [{
                name: "id",
                operator: filterOperatorTypes.anyOf,
                value: JSON.stringify(itemIds),
            }],
            sortInfo: {
                id: "id",
                dir: 0,
            }
        }

        let response = await list(props)

        // console.log('resultItems', data)

        let rows = []

        // console.log('response, response', response)

        let responseData = response?.data?.items ? response.data.items : []

        // set formik states
        responseData?.forEach(i => {

            // get the suggestQty
            let _selected = items.filter(i2 => i2.itemId.toString() === i.id.toString())

            let qty = _selected.length > 0 ? _selected[0].suggestQty : 0

            qty = parseInt(qty, 10)

            rows.push({
                itemId: i.id,
                name: i.item_name,
                description: i.description,
                code: i.code,
                uomName: i.uom_name,
                uomId: i.uom_id,
                qty,
                price: i.uom_price
            })

            // setFieldValue(`rows.${index}.itemId`, item?.id)
            // setFieldValue(`rows.${index}.name`, item?.item_name)
            // setFieldValue(`rows.${index}.description`, item?.description)
            // setFieldValue(`rows.${index}.code`, item?.code)
            // setFieldValue(`rows.${index}.uomName`, item?.uom_name)
            // setFieldValue(`rows.${index}.uomId`, item?.uom_id)
            // setFieldValue(`rows.${index}.qty`, 1)
            // setFieldValue(`rows.${index}.price`, item?.uom_price)

        })

        if (locationId) {
            setFieldValue(`locationId`, locationId)
        }

        if (locationDisplay) {
            setFieldValue(`locationName`, locationDisplay)
        }

        if (rows.length) {
            setFieldValue(`rows`, rows)
        }
    }

    return {
        init,
        catchTransition
    }
}